import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { WatcherService } from 'src/app/services/watcher.service';

@Component({
  selector: 'app-shop-bath-and-body',
  templateUrl: './shop-bath-and-body.component.html',
  styleUrls: ['./shop-bath-and-body.component.css'],
})
export class ShopBathAndBodyComponent implements OnInit, OnDestroy {
  lang: string = 'en';
  constructor(private watcherService: WatcherService, private router: Router) {}

  createBathAndBodyWorksSchema() {
    // Breadcrumb Schema
    if (!document.getElementById('shopBathAndBodyBreadcrumbSchema')) {
      const breadcrumbSchema = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "item": {
              "@id": `https://www.shippn.com//home`,
              "name": "Home"
            }
          },
          {
            "@type": "ListItem",
            "position": 2,
            "item": {
              "@id": `https://www.shippn.com//stores`,
              "name": "Best Global Stores for International Shipping"
            }
          },
          {
            "@type": "ListItem",
            "position": 3,
            "item": {
              "@id": `https://www.shippn.com//stores/how-to-shop-bath-and-body-works-and-ship-internationally`,
              "name": "How to Shop Bath & Body Works & Ship Internationally"
            }
          }
        ]
      };
      const scriptEl = document.createElement('script');
      scriptEl.type = 'application/ld+json';
      scriptEl.innerHTML = JSON.stringify(breadcrumbSchema);
      scriptEl.id = 'shopBathAndBodyBreadcrumbSchema';
      document.head.appendChild(scriptEl);
    }

    // Webpage Schema
    if (!document.getElementById('shopBathAndBodyWebpageSchema')) {
      const webpageSchema = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "How to Shop Bath & Body Works and Ship Internationally",
        "description": "Shop Bath & Body Works with ease and ship internationally using Shippn's services. Follow our step-by-step guide for a smooth global shopping experience.",
        "url": `https://www.shippn.com//stores/how-to-shop-bath-and-body-works-and-ship-internationally`
      };
      const scriptEl = document.createElement('script');
      scriptEl.type = 'application/ld+json';
      scriptEl.innerHTML = JSON.stringify(webpageSchema);
      scriptEl.id = 'shopBathAndBodyWebpageSchema';
      document.head.appendChild(scriptEl);
    }

    // Article Schema
    if (!document.getElementById('shopBathAndBodyArticleSchema')) {
      const articleSchema = {
        "@context": "https://schema.org",
        "@type": "Article",
        "headline": "How to Shop Bath & Body Works and Ship Internationally",
        "image": [
          "https://www.shippn.com/assets/img/stores/bath-and-body-works/bathandbodyworks_logo.webp",
          "https://www.shippn.com/assets/img/stores/bath-and-body-works/step-1.webp",
          "https://www.shippn.com/assets/img/stores/bath-and-body-works/step-2.webp",
          "https://www.shippn.com/assets/img/stores/bath-and-body-works/step-3.webp"
        ],
        "datePublished": "2025-03-14T12:37:01.294544Z",
        "dateModified": "2025-03-14T12:37:01.294544Z",
        "author": [{
          "@type": "Person",
          "name": "Shippn Team",
          "url": `https://www.shippn.com//about`
        }],
        "url": `https://www.shippn.com//stores/how-to-shop-bath-and-body-works-and-ship-internationally`
      };
      const scriptEl = document.createElement('script');
      scriptEl.type = 'application/ld+json';
      scriptEl.innerHTML = JSON.stringify(articleSchema);
      scriptEl.id = 'shopBathAndBodyArticleSchema';
      document.head.appendChild(scriptEl);
    }
  }

  ngOnInit(): void {
    this.watcherService.getLang().subscribe((lang) => {
      this.lang = lang;
      this.createBathAndBodyWorksSchema();
    });
  }

  goToSignIn() {
    this.router.navigate(['/','signin']);
  }

  ngOnDestroy(): void {
    const schemas = ['shopBathAndBodyBreadcrumbSchema', 'shopBathAndBodyWebpageSchema', 'shopBathAndBodyArticleSchema'];
    
    schemas.forEach(schemaId => {
      const schemaElement = document.getElementById(schemaId);
      if (schemaElement) {
        document.head.removeChild(schemaElement);
      }
    });
  }
}